import React from "react";
import BoltIcon from "@mui/icons-material/Bolt";
import TrendingUpIcon from "@mui/icons-material/TrendingUp";
import TrendingDownIcon from "@mui/icons-material/TrendingDown";
import WhatshotIcon from "@mui/icons-material/Whatshot";
import DiamondIcon from "@mui/icons-material/Diamond";
import RocketLaunchIcon from "@mui/icons-material/RocketLaunch";
import PsychologyIcon from "@mui/icons-material/Psychology";
import GpsFixedIcon from "@mui/icons-material/GpsFixed";
import BlockIcon from "@mui/icons-material/Block";
import ShieldIcon from "@mui/icons-material/Shield";
import LockIcon from "@mui/icons-material/Lock";
import HourglassEmptyIcon from "@mui/icons-material/HourglassEmpty";
import BarChartIcon from "@mui/icons-material/BarChart";
import MenuBookIcon from "@mui/icons-material/MenuBook";
import AutoStoriesIcon from "@mui/icons-material/AutoStories";
import SearchIcon from "@mui/icons-material/Search";
import WavesIcon from "@mui/icons-material/Waves";
import SpeedIcon from "@mui/icons-material/Speed";
import DoNotDisturbIcon from "@mui/icons-material/DoNotDisturb";
import HealingIcon from "@mui/icons-material/Healing";
import PaymentsIcon from "@mui/icons-material/Payments";
import TimerIcon from "@mui/icons-material/Timer";
import SwapVertIcon from "@mui/icons-material/SwapVert";
import SettingsIcon from "@mui/icons-material/Settings";
import InsightsIcon from "@mui/icons-material/Insights";
import ShowChartIcon from "@mui/icons-material/ShowChart";
import CampaignIcon from "@mui/icons-material/Campaign";
import SyncIcon from "@mui/icons-material/Sync";
import SquareFootIcon from "@mui/icons-material/SquareFoot";
import CasinoIcon from "@mui/icons-material/Casino";
import CloudIcon from "@mui/icons-material/Cloud";
import StraightenIcon from "@mui/icons-material/Straighten";

const ICON_MAP = {
  bolt: BoltIcon,
  trending_up: TrendingUpIcon,
  trending_down: TrendingDownIcon,
  whatshot: WhatshotIcon,
  diamond: DiamondIcon,
  rocket_launch: RocketLaunchIcon,
  psychology: PsychologyIcon,
  gps_fixed: GpsFixedIcon,
  block: BlockIcon,
  shield: ShieldIcon,
  lock: LockIcon,
  hourglass_empty: HourglassEmptyIcon,
  bar_chart: BarChartIcon,
  menu_book: MenuBookIcon,
  auto_stories: AutoStoriesIcon,
  search: SearchIcon,
  waves: WavesIcon,
  speed: SpeedIcon,
  do_not_disturb: DoNotDisturbIcon,
  healing: HealingIcon,
  payments: PaymentsIcon,
  timer: TimerIcon,
  swap_vert: SwapVertIcon,
  settings: SettingsIcon,
  insights: InsightsIcon,
  show_chart: ShowChartIcon,
  campaign: CampaignIcon,
  sync: SyncIcon,
  square_foot: SquareFootIcon,
  casino: CasinoIcon,
  cloud: CloudIcon,
  straighten: StraightenIcon,
};

export function getIcon(iconName, props = {}) {
  const IconComponent = ICON_MAP[iconName];
  if (IconComponent) {
    return <IconComponent {...props} />;
  }
  return null;
}

export default ICON_MAP;
